export const apiRoutes = {
  api_r_user_module_chemicalTrading_products_get_list: {
    path: 'm/chemical-trading/products/get-list/',
  },
  api_r_user_module_chemicalTrading_product_get: {
    path: 'm/chemical-trading/product/get/',
  },
  api_r_user_module_chemicalTrading_product_new: {
    path: 'm/chemical-trading/product/new/',
  },
  api_r_user_module_chemicalTrading_product_edit: {
    path: 'm/chemical-trading/product/edit/',
  },
  api_r_user_module_chemicalTrading_product_remove: {
    path: 'm/chemical-trading/product/remove/',
  },
  api_r_user_module_chemicalTrading_product_options: {
    path: 'm/chemical-trading/product-options/',
  },
  api_r_user_module_chemicalTrading_getModuleData: {
    path: 'm/chemical-trading/get-module-data/',
  },
  api_r_user_module_chemicalTrading_product_archive: {
    path: 'm/chemical-trading/product/archive/',
  },
  api_r_user_module_chemicalTrading_product_unarchive: {
    path: 'm/chemical-trading/product/unarchive/',
  },
  api_r_user_module_chemicalTrading_product_toggle_favourite: {
    path: 'm/chemical-trading/product/toggle-favourite/',
  },
  api_r_user_module_chemicalTrading_contactSeller: {
    path: 'm/chemical-trading/contact-seller/',
  },
  api_r_user_module_chemicalTrading_products_get_template: {
    path: 'm/chemical-trading/products/get-templates/',
  },
};
